import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import {
  CLIENT_USERS_LIST,
  CLIENT_USERS_ADD,
  CLIENT_USERS_UPDATE,
  CLIENT_USERS_TOGGLE_STATUS,
} from '../utils/api';

function ClientUsersCard({ customerId, customerToken }) {
  const [clientUsers, setClientUsers] = useState([]);
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    password: '',
    role: '',
    department: '',
  });

  const [editId, setEditId] = useState(null);
  const [editToken, setEditToken] = useState(null);

  useEffect(() => {
    if (customerId && customerToken) {
      fetchUsers();
    }
  }, [customerId, customerToken]);

  const fetchUsers = async () => {
    try {
      const res = await axios.post(CLIENT_USERS_LIST, {
        id: customerId,
        customer_token: customerToken,
      });
      if (res.data.success) {
        setClientUsers(res.data.client_users);
      } else {
        toast.error(res.data.message || 'Failed to fetch users');
      }
    } catch (err) {
      toast.error('Server error while fetching users');
    }
  };

const handleSaveUser = async () => {
  const { name, mobile, password, role } = form;
  if (!name || !mobile || !password || !role) {
    toast.error('All fields are required');
    return;
  }

const token = localStorage.getItem('token');
let created_by = 0;
try {
  const decoded = JSON.parse(atob(token));
  created_by = decoded.id || 0;
} catch {
  toast.error('Invalid login token');
  return;
}


  const payload = {
    ...form,
    customer_id: customerId,
    customer_token: customerToken,
    created_by,
  };

  try {
    let res;
    if (editId) {
      payload.id = editId;
      payload.client_user_token = editToken;
      res = await axios.post(CLIENT_USERS_UPDATE, payload);
    } else {
      res = await axios.post(CLIENT_USERS_ADD, payload);
    }

    if (res.data.success) {
      toast.success(res.data.message);
      setForm({ name: '', mobile: '', password: '', role: '', department: '' });
      setEditId(null);
      setEditToken(null);
      fetchUsers();
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    toast.error('Error saving user');
  }
};

  const handleEdit = (user) => {
    setForm({
      name: user.name,
      mobile: user.mobile,
      password: user.password,
      role: user.role,
      department: user.department,
    });
    setEditId(user.id);
    setEditToken(user.client_user_token);
  };

  const handleToggleStatus = async (id, status) => {
    try {
      const res = await axios.post(CLIENT_USERS_TOGGLE_STATUS, {
        id,
        status: status === 1 ? 0 : 1,
      });

      if (res.data.success) {
        toast.success(res.data.message);
        fetchUsers();
      } else {
        toast.error(res.data.message || 'Toggle failed');
      }
    } catch (err) {
      toast.error('Server error while toggling status');
    }
  };

  return (
    <div className="card shadow p-4 mt-4">
      <h5 className="mb-3">👨‍💼 Client Users</h5>

      {/* Form */}
      <div className="row g-2 mb-3">
        <div className="col-md-2">
          <input
            className="form-control"
            placeholder="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </div>
        <div className="col-md-2">
          <input
            className="form-control"
            placeholder="Mobile"
            value={form.mobile}
            onChange={(e) => setForm({ ...form, mobile: e.target.value })}
          />
        </div>
        <div className="col-md-2">
          <input
            className="form-control"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
        </div>
        <div className="col-md-2">
          <select
            className="form-select"
            value={form.role}
            onChange={(e) => setForm({ ...form, role: e.target.value })}
          >
            <option value="">Role</option>
            <option value="GatePass Maker">GatePass Maker</option>
            <option value="Team">Team</option>
            <option value="Admin">Admin</option>
          </select>
        </div>
        <div className="col-md-2">
          <input
            className="form-control"
            placeholder="Department"
            value={form.department}
            onChange={(e) => setForm({ ...form, department: e.target.value })}
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" onClick={handleSaveUser}>
            {editId ? '💾 Update' : '➕ Add'}
          </button>
        </div>
      </div>

      {/* Table */}
      {clientUsers.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>#</th>
                <th>User Name</th>
                <th>Mobile No</th>
                <th>Password</th>
                <th>Role</th>
                <th>Department</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {clientUsers.map((user, index) => (
                <tr key={user.id} className={user.status === 0 ? 'table-secondary' : ''}>

                  <td>{index + 1}</td>
                  <td>{user.name}</td>
                  <td>{user.mobile}</td>
                  <td>{user.password}</td>
                  <td>{user.role}</td>
                  <td>{user.department}</td>
                  <td>
  {user.status === 1 ? (
    <span className="badge bg-success">✅ Active</span>
  ) : (
    <span className="badge bg-danger">❌ Inactive</span>
  )}
</td>

                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEdit(user)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-warning"
                      onClick={() => handleToggleStatus(user.id, user.status)}
                    >
                      Toggle
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No users found for this customer.</p>
      )}
    </div>
  );
}

export default ClientUsersCard;
